import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

export namespace ApiTaCa010 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        deliveryYear: string
        deliveryMonth: string
        courseId: string
        planId: string
      }
    }

    // API Response
    export interface Response {
      schedules: {
        memberScheduleId: number
        lessonDate: string
        isCompleted: boolean
        subjectId: string
        subjectsName: string
      }[]
    }
  }

  // API Path
  export const path: string = '/v2/ta/calendarInfo'

  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, undefined> {
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<undefined, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        schedules: [
          {
            memberScheduleId: 0,
            lessonDate: '',
            isCompleted: false,
            subjectId: '',
            subjectsName: '',
          },
        ],
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, undefined, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        undefined
      )
    }
  }
}
